(function () {
  // Function to determine the page type
  function getPageType() {
    const url = window.location.href;

    if (url.includes("/collections/")) {
      return "collection";
    } else if (url.includes("/products/")) {
      return "product";
    }
    return null; // Not a relevant page
  }

  // Function to store page data in localStorage and cookies
  function storePageData(pageType) {
    const url = window.location.href;
    const timestamp = new Date().toISOString(); // Current timestamp

    if (pageType) {
      const data = JSON.stringify({ url, timestamp });

      // Store in localStorage
      localStorage.setItem(`${pageType}-page-data`, data);

      // Store in a cookie with expiration
      const expirationDays = 1; // Cookie expires in 1 day
      const expires = new Date();
      expires.setDate(expires.getDate() + expirationDays);

      document.cookie = `${pageType}_page_data=${encodeURIComponent(
        data
      )}; path=/; expires=${expires.toUTCString()};`;
    }
  }

  // Function to retrieve data from localStorage
  function getLocalStorageData(pageType) {
    const data = localStorage.getItem(`${pageType}-page-data`);
    return data ? JSON.parse(data) : null;
  }

  // Function to retrieve data from cookies
  function getCookieValue(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [key, value] = cookies[i].split("=");
      if (key === name) {
        return JSON.parse(decodeURIComponent(value));
      }
    }
    return null;
  }

  // Attach functions to the window object for global access
  window.rspcaSiteHistory = {
    localStorage: getLocalStorageData,
    cookieStorage: getCookieValue,
  };

  // Main logic: store data on relevant pages
  const pageType = getPageType();
  if (pageType) {
    storePageData(pageType);
  }
})();
